import * as publicActions from '../actions/public'
import * as api from '../../api'
import * as orderSelectors from '../../selectors/order'

export const getTimeslots = () => (dispatch, getState) => {
  const state = getState()
  const zipcode = orderSelectors.getZipcode(state).value

  dispatch(publicActions.getTimeslots())
  return api
    .getTimeslots({ zipcode })
    .then(res =>
      dispatch(publicActions.getTimeslotsSuccess(res.data.timeslots))
    )
    .catch(err => dispatch(publicActions.getTimeslotsFail(err)))
}

export const getUpcomingDays = () => (dispatch, getState) => {
  const state = getState()
  const zipcode = orderSelectors.getZipcode(state).value

  dispatch(publicActions.getUpcomingDays())
  return api
    .getUpcomingDays({ zipcode })
    .then(res =>
      dispatch(publicActions.getUpcomingDaysSuccess(res.data.upcomingDays))
    )
    .catch(err => dispatch(publicActions.getUpcomingDaysFail(err)))
}

export const getMenu = () => (dispatch, getState) => {
  const state = getState()
  const zipcode = orderSelectors.getZipcode(state).value
  const date = orderSelectors.getSelectedDeliveryDay(state).value

  dispatch(publicActions.getMenu())
  return api
    .getMenu({ zipcode, date })
    .then(res => dispatch(publicActions.getMenuSuccess(res.data.menu)))
    .catch(err => dispatch(publicActions.getMenuFail(err)))
}



// WEBPACK FOOTER //
// ./src/store/effects/public.js